// eslint-disable-next-line import/no-relative-packages
import { Location } from '../../universal-dashboard-api/src/Data-Processor/Entities/Interfaces/Summary';

export interface UniversalDashboardConfiguration {
  apiUrl: string;
}

export type DeviceGroupStyleProperties = {
  bg: string;
  fill: string;
  raw: string;
  stroke: string;
};

export type DeviceGroupStyles = Record<string, DeviceGroupStyleProperties>;

export type DeviceValue = {
  type: string;
  value: number;
};

export type LocationWithAssetCount = Location & {
  count?: number;
};

export enum CustomerType {
  Commercial = 'Commercial',
  Domestic = 'Domestic',
}

export interface FeatureShape {
  type: 'Feature';
  id: string;
  geometry: { coordinates: [number, number][][]; type: 'Polygon' };
  properties: { name: string };
}
